<template>
<div>
    <div class="col-md-12">
        <div class="row" style="margin-top: 20px">
            <div class="col-md-6" v-if="!embedded">
                <h3 class="page-header">
                    <i class="fa fa-truck animated bounceInDown show-info"></i>
                    <span>To be Dispatched</span>
                </h3>
            </div>
            <div class="text-right" :class="embedded ? 'col-md-12' : 'col-md-6'">
                <span class="control-label">Total:</span>
                <span class="badge bg-danger">{{ orders.length }}</span>
                <button @click="refresh()" class="btn btn-refresh"><i class="fa fa-refresh"></i></button>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <p class="text-muted">
            {{ isadmin ? 'All approved orders.' : 'Approved orders assigned to you.' }}
            Enter the serial no. of the product and dispatch it; the delivery boy can then accept it.
        </p>
        <div class="panel">
            <div class="table-responsive panel-body">
                <table class="table users-table table-condensed table-hover table-bordered table-sm">
                    <thead class="table-font" style="font-size:13px;">
                        <tr>
                            <th>#</th>
                            <th>Order No.</th>
                            <th>Customer</th>
                            <th>Mobile</th>
                            <th>Address</th>
                            <th>Product</th>
                            <th>Remark</th>
                            <th v-if="isadmin">Assign To</th>
                            <th>Delivery Boy</th>
                            <th>Dispatch</th>
                        </tr>
                    </thead>
                    <tbody class="table-font" style="font-size:13px;">
                        <tr v-if="!loading && orders.length == 0">
                            <td :colspan="isadmin ? 10 : 9" class="text-center">No orders to dispatch</td>
                        </tr>
                        <tr v-for="(item, index) in orders" :key="item.id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.complaintno }}<br>{{ moment(item.created_at).format('DD-MM-YYYY') }}</td>
                            <td>
                                <span v-if="item.customer">{{ item.customer.name }}<br>{{ item.customer.generatedid }}</span>
                                <span v-else>{{ item.customername }}</span>
                            </td>
                            <td>
                                <display-mobiles v-if="item.customer" :mobiles="item.customer.mobiles"></display-mobiles>
                                <span v-else>{{ item.customermobile }}</span>
                            </td>
                            <td>
                                <display-first-address v-if="item.customer" :addresses="item.customer.addressess"></display-first-address>
                                <span v-else>{{ item.customeraddress }}</span>
                            </td>
                            <td>{{ item.product?.category?.name }} {{ item.product?.name }}</td>
                            <td>{{ item.remark }}</td>
                            <td v-if="isadmin">{{ item.followby?.name || '-' }}</td>
                            <td>
                                <span v-if="item.deliveryboy" style="font-weight:600">{{ item.deliveryboy.name }}</span>
                                <span v-else style="color:#c0392b">Not assigned</span>
                            </td>
                            <td style="min-width:220px">
                                <div v-if="!item.deliveryboy" style="color:#c0392b">
                                    Assign a delivery boy (order conversation) before dispatching.
                                </div>
                                <div v-else>
                                    <input class="form-control input-small" v-model="serials[item.id]" type="text"
                                        placeholder="Serial no. *"/>
                                    <button class="btn btn-success btn-xs" style="margin-top:4px"
                                        :disabled="savingid == item.id" @click="dispatch(item)">
                                        {{ savingid == item.id ? 'Saving...' : 'Dispatch' }}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import DisplayFirstAddress from '../../components/address/DisplayFirstAddress.vue'
import DisplayMobiles from '../../components/mobile/DisplayMobiles.vue'
export default {
    components: { DisplayFirstAddress, DisplayMobiles },
    // embedded: shown as a tab of Dispatch & Returns (no page title)
    props: { embedded: { type: Boolean, default: false } },
    data() {
        return {
            moment: moment,
            orders: [],
            loading: false,
            savingid: null,
            serials: {}
        }
    },
    computed: {
        ...mapGetters(['loggedinuser']),
        // admins get every approved order from the backend (role > 1)
        isadmin() {
            return (this.loggedinuser?.role ?? 0) > 1
        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        refresh() {
            this.loading = true
            this.$store.commit('assignloadingstatus', 1)
            this.$http.post('api/vsdigi/leads/orders/to-dispatch', {})
                .then((response) => {
                    this.orders = response.data || []
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to load orders', type: 'error' })
                })
                .finally(() => {
                    this.loading = false
                    this.$store.commit('assignloadingstatus', 0)
                })
        },
        dispatch(item) {
            const serialno = (this.serials[item.id] || '').trim()
            if (!serialno) {
                this.$notify({ text: 'Enter the serial no. to dispatch', type: 'error' })
                return
            }
            this.savingid = item.id
            this.$http.post('api/vsdigi/leads/orders/dispatch', { id: item.id, serialno: serialno })
                .then(() => {
                    this.$notify({ text: 'Order dispatched', type: 'success' })
                    this.refresh()
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to dispatch the order', type: 'error' })
                })
                .finally(() => {
                    this.savingid = null
                })
        }
    }
}
</script>
